export default "/assets/modules/images/circles-background-blue.png?8e65e3a5058d16e10173c68cda4f2d52";